const sessionId = `${Math.random().toString(36).substring(2, 15)}_${Date.now()}`;

// Appends a unique query parameter to the image source URL to prevent caching
// Due to the fact that provided SVGs are actually PNG images in disguise, and the browser cant properly load them from cache.
export const generateNonCachableImageSrc = (src: string): string => `${src}?v=${sessionId}`;
